VjsAdmin.Licenses = (function () {
    const me = {};

    me.$licenses_table = $('#licenses-table');
    me.platform_id = me.$licenses_table.attr('data-platform-id');
    me.district_joint_guid = me.$licenses_table.attr('data-district-joint-guid');

    // include usage stuffs
    me.licenses_include_usage = 0;
    me.licenses_date_range_from = null;
    me.licenses_date_range_to = null;

    // bulk edit stuffs
    me.bulk_edit_max = 250;
    me.selections = [];
    me.$bulk_edit_modal = null;
    me.$bulk_edit_response_modal = null;
    me.districts_order_by = 'district_id';
    me.districts_sort_order = 'desc';
    me.districts_table_height = window.innerHeight * 0.55;

    me.licensesTableQueryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);

        myParams.include_usage = me.licenses_include_usage;
        myParams.date_range_from = me.licenses_date_range_from == null ? null : me.licenses_date_range_from.format();
        myParams.date_range_to = me.licenses_date_range_to == null ? null : me.licenses_date_range_to.format();

        myParams.active = null;
        myParams.expire_in_days = null;
        myParams.activated_in_days = null;
        myParams.exceeding_user_limit = null;
        switch (this.search_status) {
            case 'all':
                myParams.active = null;
                break;
            case 'active':
                myParams.active = 1;
                break;
            case 'expired':
                myParams.active = 0;
                break;
            case 'expire-30':
                myParams.active = 1;
                myParams.expire_in_days = 30;
                break;
            case 'expire-60':
                myParams.active = 1;
                myParams.expire_in_days = 60;
                break;
            case 'expire-90':
                myParams.active = 1;
                myParams.expire_in_days = 90;
                break;
            case 'activate-30':
                myParams.active = 1;
                myParams.activated_in_days = 30;
                break;
            case 'activate-60':
                myParams.active = 1;
                myParams.activated_in_days = 60;
                break;
            case 'activate-90':
                myParams.active = 1;
                myParams.activated_in_days = 90;
                break;
            case 'exceeding-user-limit':
                myParams.active = 1;
                myParams.exceeding_user_limit = 1;
                break;
            case 'within-user-limit':
                myParams.active = 1;
                myParams.exceeding_user_limit = 0;
                break;
            default:
                break;
        }
        return myParams;
    };

    me.init = function () {
        $('#include-usage-stats').prop('checked', false);

        me.initLicensesTable();

        // handle export of data
        $('.app-content').on('click', '#export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = me.licensesTableQueryParams.call(me.$licenses_table.bootstrapTable('getOptions'));
            const visibleColumns = me.$licenses_table.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            if ($('#include-usage-stats').prop('checked')) {
                exportColumns.usage_date_range = 'Usage Date Range';
            }
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        /// //////////////////////////////////////
        // handle the Include Usage Stats button...
        //
        $('.app-content').on('click', '#include-usage-toggle, #include-usage-stats', (e) => {
            e.preventDefault();
            if (+me.licenses_include_usage === 1) {
                $('#include-usage-stats').prop('checked', false);
                me.licenses_include_usage = 0;
                me.$licenses_table.bootstrapTable('refreshOptions', {
                    columns: +me.platform_id === 1 ? me.vjs_columns_without_usage : me.jr_columns_without_usage,
                });
                me.setupBulkEditLicenses();
            } else {
                me.$date_range_modal.modal({
                    backdrop: 'static',
                    keyboard: false,
                });
            }
            return false;
        });

        const dateRangeForm = $('<div>').html($('#date-range-form-template').html());

        const $continueButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Continue</button>');

        $continueButton.on('click', (e) => {
            e.preventDefault();

            let errors = false;
            if ($('#date_range_from').val() === '') {
                $('#date_range_from').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#date_range_from').removeClass('is-invalid').addClass('is-valid');
            }
            if ($('#date_range_to').val() === '') {
                $('#date_range_to').removeClass('is-valid').addClass('is-invalid');
                errors = true;
            } else {
                $('#date_range_to').removeClass('is-invalid').addClass('is-valid');
            }

            if (errors) {
                return false;
            }

            // if we're here, we have good dates, lets refresh the table with include_usage set to ON
            me.licenses_include_usage = 1;

            if (
                typeof $('#date_range_from').val() !== 'undefined'
                && $('#date_range_from').val() !== null
                && $('#date_range_from').val() !== ''
            ) {
                $('#date_range_from').val(moment($('#date_range_from').val()).utc().format());
                me.licenses_date_range_from = moment($('#date_range_from').val()).utc();
            }
            if (
                typeof $('#date_range_to').val() !== 'undefined'
                && $('#date_range_to').val() !== null
                && $('#date_range_to').val() !== ''
            ) {
                $('#date_range_to').val(moment($('#date_range_to').val()).utc().format());
                me.licenses_date_range_to = moment($('#date_range_to').val()).utc();
            }

            // refresh the table, with the usage columns shown...
            let columns;
            switch (me.platform_id) {
                case '1':
                    columns = { columns: me.vjs_columns_with_usage };
                    break;
                case '4':
                    columns = { columns: me.cp_columns_with_usage };
                    break;
                default:
                    columns = { columns: me.jr_columns_with_usage };
                    break;
            }
            me.$licenses_table.bootstrapTable('refreshOptions', columns);

            // set the checkbox to 'checked'
            $('#include-usage-stats').prop('checked', true);

            me.$date_range_modal.modal('hide');

            me.setupBulkEditLicenses();

            return true;
        });

        me.$date_range_modal = VjsAdmin.Modal.create({
            id: 'include-usage-modal',
            title: 'Choose Date Range for Usage Stats',
            body: dateRangeForm,
            footer: $continueButton,
            onShown() {
                VjsAdmin.initDateRangePickers($('#include-usage-modal'));
            },
        });

        me.$licenses_table.on('click', 'th.date-range-header', () => {
            me.$date_range_modal.modal({ backdrop: 'static', keyboard: false });
        });

        me.setupBulkEditLicenses();
    };

    me.initLicensesTable = function () {
        me.$licenses_table.addClass('loading');

        me.$licenses_table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#licenses-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                const activeStatus = this.search_status;
                let type = '';
                switch (activeStatus) {
                    case 'all':
                        type = 'licenses';
                        break;
                    case 'active':
                        type = '<strong>active</strong> licenses';
                        break;
                    case 'expired':
                        type = '<strong>expired</strong> licenses';
                        break;
                    default:
                        type = `licenses <strong>${$('#search-status option:selected').text()}</strong>`;
                        break;
                }
                return `No ${type}${typeof searchTerm !== 'undefined' && searchTerm !== '' ? ` matching search term \`${SafeDOM.escapeHtml(searchTerm)}\`` : ''
                    } in this district.`;
            },
            idField: 'license_id',
            toolbar: '#report-toolbar',
            toolbarAlign: 'left',
            sortName: 'license_name',
            sortOrder: 'desc',
            search_status: 'active',
            showColumns: true,
            clickToSelect: true,
            url: Slim.Router.pathFor('platforms.districts.licenses.list.json', {
                platform_id: me.platform_id,
                district_joint_guid: me.district_joint_guid,
            }),
            queryParams: me.licensesTableQueryParams,
            columns: +me.platform_id === 1 ? me.vjs_columns_without_usage : me.jr_columns_without_usage,
            onUncheckAll() {
                me.selections = [];
                me.updateSelectedLicensesCount();
            },
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    const diffHours = moment().diff(moment(result.date_created).utc(), 'hours');

                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.is_active = row.active;

                    row.checkbox = $.inArray(row.license_id, me.selections) !== -1;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.disable_links === 0) {
                        row.disable_links = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else if (+row.disable_links === 1) {
                        row.disable_links = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.license_searchable === 0) {
                        row.license_searchable = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else if (+row.license_searchable === 1) {
                        row.license_searchable = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    row.time_spent = VjsAdmin.secondsToHoursMinutes(row.time_spent);

                    if (row.user_count > row.user_account_limit) {
                        row.user_account_limit += '<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>';
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.view')) {
                        const statsUrl = Slim.Router.pathFor('platforms.districts.licenses.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.license_name = `<a href="${SafeDOM.escapeHtml(statsUrl)}">${SafeDOM.escapeHtml(row.license_name)}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.users.list')) {
                        const usersUrl = Slim.Router.pathFor('platforms.districts.licenses.users.list', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.user_count = `<a href="${SafeDOM.escapeHtml(usersUrl)}?search_roles=users">${row.user_count}</a>`;
                        row.admin_count = `<a href="${SafeDOM.escapeHtml(usersUrl)}?search_roles=admins">${row.admin_count}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.groups.list')) {
                        const groupsUrl = Slim.Router.pathFor('platforms.districts.licenses.groups.list', {
                            platform_id: me.platform_id,
                            district_joint_guid: me.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.group_count = `<a href="${SafeDOM.escapeHtml(groupsUrl)}">${row.group_count}</a>`;
                    }

                    row.actions = '';
                    if (VjsAdmin.hasPermission('platforms.districts.licenses.edit.view') && me.platform_id !== '1') {
                        const editLicenseUrl = Slim.Router.pathFor('platforms.districts.licenses.edit.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.actions += `<a href="${SafeDOM.escapeHtml(editLicenseUrl)}" class="action-link">Edit</a>`;
                    }
                    if (VjsAdmin.hasPermission('platforms.districts.licenses.clone.view') && me.platform_id !== '1') {
                        const cloneLicenseUrl = Slim.Router.pathFor('platforms.districts.licenses.clone.view', {
                            platform_id: me.platform_id,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.actions += `<a href="${SafeDOM.escapeHtml(cloneLicenseUrl)}" class="action-link">Clone</a>`;
                    }

                    if (diffHours < 24) {
                        row.license_name += ' <span class="badge badge-pill badge-success new-badge">NEW</span>';
                    }
                });
                return formattedResult;
            },
            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);

                const thisTable = this;

                $('#search-status').off();
                $('#search-status').on('change', () => {
                    thisTable.search_status = $('#search-status option:selected').val();
                    thisTable.updateUrl();
                    $('#licenses-table').bootstrapTable('refresh');
                });

                if (typeof this.default_search_status === 'undefined') {
                    this.default_search_status = this.search_status;
                }
                this.search_status = $.urlParam('search_status') != null ? $.urlParam('search_status') : this.default_search_status;
                $(`#search-status option[value=${this.search_status}]`).attr('selected', true);
            },
            onLoadSuccess(data) {
                VjsTable.tableDefaults().onLoadSuccess.call(this, data);
                me.updateDateRangeHeader();
            },
            updateUrl() {
                const queryParams = {};
                if (this.search_status !== this.default_search_status) {
                    queryParams.search_status = this.search_status;
                }
                VjsTable.tableDefaults().updateUrl.call(this, queryParams);
            },
            onSort(name, order) {
                VjsTable.tableDefaults().onSort.call(this, name, order);
                me.updateDateRangeHeader();
            },
            onColumnSwitch() {
                $(this.table).bootstrapTable('refresh');
            },
        });
    };

    me.updateDateRangeHeader = function () {
        if (
            typeof me.licenses_date_range_from !== 'undefined'
            && me.licenses_date_range_from != null
            && typeof me.licenses_date_range_to !== 'undefined'
            && me.licenses_date_range_to != null
        ) {
            var $link = $('<a>').attr('href', '#');
            $link.append($('<i>').addClass('fa fa-calendar').attr('aria-hidden', 'true'));
            $link.append(document.createTextNode(' ' + me.licenses_date_range_from.format('l') + ' to  '));
            $link.append($('<i>').addClass('fa fa-calendar').attr('aria-hidden', 'true'));
            $link.append(document.createTextNode(' ' + me.licenses_date_range_to.format('l')));
            me.$licenses_table.find('th.date-range-header').empty().append($link);
        } else if (typeof me.licenses_date_range_from !== 'undefined' && me.licenses_date_range_from != null) {
            var $linkFrom = $('<a>').attr('href', '#');
            $linkFrom.append($('<i>').addClass('fa fa-calendar').attr('aria-hidden', 'true'));
            $linkFrom.append(document.createTextNode(' ' + me.licenses_date_range_from.format('l') + ' to Now'));
            me.$licenses_table.find('th.date-range-header').empty().append($linkFrom);
        }
    };

    me.vjs_columns_without_usage = [
        {
            field: 'checkbox',
            title: 'Edit',
            checkbox: true,
            visible: false,
        },
        {
            title: 'ID',
            field: 'license_id',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Name',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'State',
            field: 'state_code',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'City',
            field: 'city',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'User<br>Limit',
            field: 'user_account_limit',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Users',
            field: 'user_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Admins',
            field: 'admin_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Disable Links?',
            field: 'disable_links',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Searchable?',
            field: 'license_searchable',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'Rostering',
            field: 'rostering_type',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'OneRoster&reg; ID',
            field: 'oneroster_id',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Clever ID',
            field: 'clever_id',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
            field: 'activation_date',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
            field: 'expiration_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: false,
            switchable: false,
        },
    ];

    me.vjs_columns_with_usage = [
        [
            {
                field: 'checkbox',
                title: 'Edit',
                checkbox: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'ID',
                field: 'license_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Name',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'City',
                field: 'city',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'User<br>Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Groups',
                field: 'group_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'QA Videos<br>Watched',
                field: 'videos_watched_qa',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Career<br>Journals',
                field: 'career_journals',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Assessments<br>Completed',
                field: 'assessments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Assignments<br>Completed',
                field: 'assignments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Résumés<br>Completed',
                field: 'resumes_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Quizzes<br>Completed',
                field: 'quiz_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Goals<br>Created',
                field: 'goals_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Disable Links?',
                field: 'disable_links',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Searchable?',
                field: 'license_searchable',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Rostering',
                field: 'rostering_type',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'OneRoster&reg; ID',
                field: 'oneroster_id',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Clever ID',
                field: 'clever_id',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                switchable: false,
                sortable: false,
                colspan: 8,
                class: 'date-range-header',
            },
        ],
    ];

    me.cp_columns_with_usage = [
        [
            {
                title: 'District',
                field: 'district_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Name',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'ID',
                field: 'license_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'User<br>Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Groups',
                field: 'group_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Disable Links?',
                field: 'disable_links',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Searchable?',
                field: 'license_searchable',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                switchable: false,
                sortable: false,
                colspan: 3,
                class: 'date-range-header',
            },
        ],
    ];

    me.jr_columns_without_usage = [
        {
            field: 'checkbox',
            title: 'Edit',
            checkbox: true,
            visible: false,
        },
        {
            title: 'ID',
            field: 'license_id',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Name',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'State',
            field: 'state_code',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'City',
            field: 'city',
            align: 'left',
            valign: 'middle',
            sortable: true,
            visible: false,
        },
        {
            title: 'User<br>Limit',
            field: 'user_account_limit',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Users',
            field: 'user_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Admins',
            field: 'admin_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Groups',
            field: 'group_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Rostering',
            field: 'rostering_type',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'OneRoster&reg; ID',
            field: 'oneroster_id',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'Clever ID',
            field: 'clever_id',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
            field: 'activation_date',
            align: 'left',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
            field: 'expiration_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: false,
            switchable: false,
        },
    ];

    me.jr_columns_with_usage = [
        [
            {
                field: 'checkbox',
                title: 'Edit',
                checkbox: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'ID',
                field: 'license_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'Name',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'City',
                field: 'city',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'User<br>Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Groups',
                field: 'group_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Cluster<br>Videos<br>Watched',
                field: 'videos_watched_cluster',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Career<br>Videos<br>Watched',
                field: 'videos_watched_career',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'QA<br>Videos<br>Watched',
                field: 'videos_watched_career_qa',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Lessons<br>Completed',
                field: 'lessons_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'Assessments<br>Completed',
                field: 'assessments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: true,
            },
            {
                title: 'OneRoster&reg; ID',
                field: 'oneroster_id',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Clever ID',
                field: 'clever_id',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                switchable: false,
                sortable: false,
                colspan: 3,
                class: 'date-range-header',
            },
        ],
    ];

    me.setupBulkEditLicenses = function () {
        if (VjsAdmin.hasPermission('platforms.districts.licenses.bulk_edit.post')) {
            me.$bulk_edit_buttons = $('<div class="columns columns-right btn-group float-right"></div>');
            me.$bulk_edit_enable_button = $(
                '<button id="enable-bulk-edit-mode" class="btn btn-hollow-pink" type="button" name="refresh" aria-label="refresh" title="Enable Bulk Edit Mode"><i class="fa-regular fa-square-check" aria-hidden="true"></i> Enable Bulk Edit Mode</button>',
            );
            me.$bulk_edit_edit_button = $(
                '<button id="edit-licenses-btn" class="btn btn-hollow-pink" type="button" name="refresh" aria-label="refresh" data-toggle="tooltip" data-placement="top" title="Select Licenses to Bulk Edit, then click here to choose an action" style="display:none;">Bulk Edit <span class="selected-licenses-count">0 Licenses</span></button>',
            );
            me.$bulk_edit_done_button = $(
                '<button class="btn btn-hollow-dark-gray" type="button" name="refresh" aria-label="refresh" title="Done" style="display:none;">Done</button>',
            );
            me.$bulk_edit_enable_button.on('click', me.enableBulkEditMode);
            me.$bulk_edit_done_button.on('click', me.disableBulkEditMode);

            // when they click on the bulk edit button, show the modal
            me.$bulk_edit_edit_button.on('click', () => {
                if (me.selections.length > 0) {
                    me.updateSelectedLicensesCount();
                    me.$bulk_edit_edit_button.tooltip('hide');
                    me.$bulk_edit_modal.modal({
                        backdrop: 'static',
                        keyboard: false,
                    });
                }
            });

            me.$bulk_edit_buttons.append(me.$bulk_edit_enable_button);
            me.$bulk_edit_buttons.append(me.$bulk_edit_edit_button);
            me.$bulk_edit_buttons.append(me.$bulk_edit_done_button);

            const $bulkEditLicenseForm = $('<div>').html($('#bulk-edit-licenses-form-template').html());
            const $saveButton = $(
                `<button id="bulk-edit-save-changes" type="button" class="btn btn-blue" data-dismiss="modal">Save Changes for <span class="selected-licenses-count">${me.selections.length} Licenses</span></button>`,
            );
            const $cancelButton = $('<button type="button" class="btn btn-hollow-dark-gray" data-dismiss="modal">Cancel</button>');

            $saveButton.on('click', (e) => {
                e.preventDefault();
                $('#bulk-edit-modal .modal-body .alert').remove();
                $('#bulk-edit-modal .modal-body input').removeClass('is-invalid').removeClass('is-valid');
                const action = $('#bulk-edit-action').val();
                const data = {};
                data.licenses = me.selections;
                data.action = action;
                const errors = [];

                // validate form
                switch (action) {
                    case 'dates':
                        if ($('#bulk_edit_date_range_from').val() === '') {
                            $('#bulk_edit_date_range_from').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must set a valid "Activation" date');
                        } else {
                            $('#bulk_edit_date_range_from').removeClass('is-invalid').addClass('is-valid');
                            $('#bulk_edit_date_range_from').val(moment($('#bulk_edit_date_range_from').val()).utc().format());
                            data.date_range_from = moment($('#bulk_edit_date_range_from').val()).utc().format();
                        }
                        if ($('#bulk_edit_date_range_to').val() === '') {
                            $('#bulk_edit_date_range_to').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must set a valid "Expiration" date');
                        } else {
                            $('#bulk_edit_date_range_to').removeClass('is-invalid').addClass('is-valid');
                            $('#bulk_edit_date_range_to').val(moment($('#bulk_edit_date_range_to').val()).utc().format());
                            data.date_range_to = moment($('#bulk_edit_date_range_to').val()).utc().format();
                        }
                        break;
                    case 'searchability': {
                        const searchable = $("#bulk-edit-licenses-form input[name='searchable']:checked").val();
                        if (typeof searchable !== 'undefined') {
                            data.searchable = searchable;
                        } else {
                            $('#bulk_edit_searchable-on').removeClass('is-valid').addClass('is-invalid');
                            $('#bulk_edit_searchable-off').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must select either "yes" or "no". Come on!');
                        }
                        break;
                    }
                    case 'sso':
                        $('#bulk-edit-licenses-form #custom-form-fields .form-control').each((i, el) => {
                            data[$(el).attr('name')] = $(el).val();
                        });
                        break;
                    case 'district':
                        if ($('#bulk_edit_district_id').val() === '') {
                            $('#bulk_edit_district_id').removeClass('is-valid').addClass('is-invalid');
                            errors.push("You must select a dang ol' district!");
                        } else {
                            $('#bulk_edit_district_id').removeClass('is-invalid').addClass('is-valid');
                            data.district_id = $('#bulk_edit_district_id').val();
                        }
                        break;
                    case 'account_limit':
                        if ($('#bulk_edit_user_account_limit').val() === '') {
                            $('#bulk_edit_user_account_limit').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must enter a new account limit number in that there field!');
                        } else {
                            $('#bulk_edit_user_account_limit').removeClass('is-invalid').addClass('is-valid');
                            data.account_limit = $('#bulk_edit_user_account_limit').val();
                        }
                        break;
                    case 'featured_careers':
                        if ($('#bulk-edit-featured-careers option:selected').val() === '') {
                            $('#bulk-edit-featured-careers option:selected').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must featured career in that there fields!');
                        } else {
                            $('#bulk-edit-featured-careers option:selected').removeClass('is-invalid').addClass('is-valid');
                            data.featured_careers = $('#bulk-edit-featured-careers option:selected').val();
                        }
                        break;
                    default:
                        break;
                }

                if (errors.length > 0) {
                    $.each(errors, (i, error) => {
                        $('#bulk-edit-modal .modal-body').prepend( // noaikido — errors[] contains only hardcoded string literals from the switch statement above, no user input
                            `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${error}</div>`,
                        );
                    });
                    return false;
                }

                $('body').css('cursor', 'wait');
                $('.app').addClass('light-blur');
                $('#ajax-progress-indicator').fadeIn();
                $.ajax({
                    url: Slim.Router.pathFor('platforms.districts.licenses.bulk_edit.post', {
                        platform_id: me.platform_id,
                        district_joint_guid: me.district_joint_guid,
                    }),
                    dataType: 'json',
                    method: 'POST',
                    data,
                    async: true,
                })
                    .done((responseData) => {
                        if (typeof responseData.meta.failures !== 'undefined' && responseData.meta.failures > 0) {
                            $.each(responseData.data.failure, (i, message) => {
                                me.$bulk_edit_response_modal
                                    .find('.modal-body')
                                    .append(SafeDOM.makeAlertDiv(message, 'danger', 'fa fa-exclamation-triangle'));
                            });
                            $.each(responseData.data.success, (i, message) => {
                                me.$bulk_edit_response_modal
                                    .find('.modal-body')
                                    .append(SafeDOM.makeAlertDiv(message, 'success', 'fa fa-thumbs-up'));
                            });
                            me.$bulk_edit_response_modal.modal({
                                backdrop: 'static',
                                keyboard: false,
                            });
                        } else if (action === 'dates' || action === 'district') {
                            window.location.reload();
                        }
                    })
                    .fail((jqXHR, textStatus, errorThrown) => {
                        if (+jqXHR.status === 400) {
                            me.$bulk_edit_response_modal
                                .find('.modal-body')
                                .prepend(SafeDOM.makeAlertDiv(jqXHR.responseJSON.message, 'danger', 'fa fa-exclamation-triangle'));
                        } else {
                            me.$bulk_edit_response_modal
                                .find('.modal-body')
                                .prepend(SafeDOM.makeAlertDiv(errorThrown, 'danger', 'fa fa-exclamation-triangle'));
                        }
                        me.$bulk_edit_response_modal.modal({
                            backdrop: 'static',
                            keyboard: false,
                        });
                    })
                    .always(() => {
                        $('body').css('cursor', 'default');
                        $('.app').removeClass('light-blur');
                        $('#ajax-progress-indicator').fadeOut();
                        me.updateSelectedLicensesCount();
                        me.disableBulkEditMode();
                        me.$licenses_table.bootstrapTable('refresh', {
                            silent: true,
                        });
                        me.$bulk_edit_modal.modal('hide');
                    });

                me.$bulk_edit_edit_button.prop('disabled', false);
                me.updateSelectedLicensesCount();
                return false;
            });

            $cancelButton.on('click', () => {
                $('#bulk-edit-modal .modal-body .alert').remove();
                $('#bulk-edit-modal .modal-body input').removeClass('is-invalid').removeClass('is-valid');
                me.$bulk_edit_edit_button.prop('disabled', false);
                me.updateSelectedLicensesCount();
            });

            const $modalFooter = $('<div></div>');
            $modalFooter.append($cancelButton);
            $modalFooter.append($saveButton);

            if (me.$bulk_edit_modal == null) {
                me.$bulk_edit_modal = VjsAdmin.Modal.create({
                    id: 'bulk-edit-modal',
                    title: `Bulk Edit <span class="selected-licenses-count">${me.selections.length} Licenses</span>`,
                    body: $bulkEditLicenseForm,
                    footer: $modalFooter,
                    no_close: true,
                    onShown() {
                        me.updateSelectedLicensesCount();
                        $('#bulk-edit-action').off('change');
                        $('#bulk-edit-action').on('change', function () {
                            $('#bulk-edit-modal .modal-body .alert').remove();
                            const action = $(this).val();
                            $('#custom-form-fields')
                                .html('')
                                .append($(`#bulk-edit-licenses-${action}`).html());
                            if (action === '') {
                                $('#custom-form-fields-container').hide();
                            } else {
                                if (action === 'dates') {
                                    VjsAdmin.initDateRangePickers($('#custom-form-fields'));
                                } else if (action === 'district') {
                                    me.initDistrictsTable();
                                }
                                $('#custom-form-fields-container').show();
                            }
                        });
                    },
                });
            }

            const $closeButton = $('<button type="button" class="btn btn-hollow-dark-gray" data-dismiss="modal">Close</button>');

            if (me.$bulk_edit_response_modal == null) {
                me.$bulk_edit_response_modal = VjsAdmin.Modal.create({
                    id: 'bulk-edit-response-modal',
                    title: 'Bulk Edit Results',
                    body: '',
                    footer: $closeButton,
                    onHidden() {
                        $('#bulk-edit-response-modal .modal-body .alert').remove();
                    },
                });
            }

            me.$licenses_table.on('check.bs.table check-all.bs.table uncheck.bs.table uncheck-all.bs.table', (e, rows) => {
                const licenseIds = $.map(!$.isArray(rows) ? [rows] : rows, (row) => row.license_id);
                if (e.type === 'check' || e.type === 'check-all') {
                    if (licenseIds.length + me.selections.length > me.bulk_edit_max) {
                        window.alert('You have reached the max # of licenses to bulk edit at one time!');
                        me.$licenses_table.bootstrapTable('uncheckBy', {
                            field: 'user_id',
                            values: _.difference(licenseIds, me.selections),
                        });
                        return false;
                    }
                }
                const func = $.inArray(e.type, ['check', 'check-all']) > -1 ? 'union' : 'difference';
                me.selections = _[func](me.selections, licenseIds);
                me.updateSelectedLicensesCount();
            });

            me.addButtons();
        }
    };

    me.updateSelectedLicensesCount = function () {
        $('.selected-licenses-count').text(`${me.selections.length} License${+me.selections.length === 1 ? '' : 's'}`);
    };

    me.enableBulkEditMode = function () {
        me.updateSelectedLicensesCount();
        me.$bulk_edit_enable_button.hide();
        me.$bulk_edit_edit_button.show();
        me.$bulk_edit_edit_button.tooltip('show');
        me.$bulk_edit_done_button.show();
        me.$licenses_table.bootstrapTable('showColumn', 'checkbox');
        me.$licenses_table.bootstrapTable('hideColumn', 'actions');
        me.updateDateRangeHeader();
    };

    me.disableBulkEditMode = function () {
        me.updateSelectedLicensesCount();
        me.$bulk_edit_enable_button.show();
        me.$bulk_edit_edit_button.hide();
        me.$bulk_edit_done_button.hide();
        me.$licenses_table.bootstrapTable('hideColumn', 'checkbox');
        me.$licenses_table.bootstrapTable('showColumn', 'actions');
        me.updateDateRangeHeader();
    };

    me.addButtons = function () {
        me.$licenses_table.closest('.bootstrap-table').find('.fixed-table-toolbar .columns-right').after(me.$bulk_edit_buttons);
    };

    me.districtsTableQueryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
        myParams.sort_order = me.districts_sort_order;
        myParams.order_by = me.districts_order_by;
        myParams.search_term = $('#bulk-edit-licenses-form .fixed-table-toolbar .search > input').val();
        return myParams;
    };

    me.initDistrictsTable = function () {
        me.$districts_table = $('#districts-table');
        me.$districts_table.addClass('loading');

        me.$districts_table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#districts-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No districts ${typeof searchTerm !== 'undefined' ? ` matching search term \`${SafeDOM.escapeHtml(searchTerm)}\`` : ''}`;
            },
            queryParams: me.districtsTableQueryParams,
            toolbar: null,
            toolbarAlign: 'left',
            sortName: 'district_id',
            height: me.districts_table_height,
            singleSelect: true,
            clickToSelect: true,
            maintainSelected: true,
            onCheck(row) {
                $('#bulk_edit_district_id').val(row.district_id);
            },
            url: Slim.Router.pathFor('platforms.districts.list.json', {
                platform_id: me.platform_id,
            }),
            columns: [
                {
                    title: '',
                    field: 'selected',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    radio: true,
                },
                {
                    title: 'ID',
                    field: 'district_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'State',
                    field: 'state_code',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, row) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row.is_active = row.active;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }
                });
                return formattedResult;
            },
            onLoadSuccess(data) {
                VjsTable.tableDefaults().onLoadSuccess.call(this, data);
                me.updateDateRangeHeader();
            },
            onSort(name, order) {
                VjsTable.tableDefaults().onSort.call(this, name, order);
                me.districts_order_by = name;
                me.districts_sort_order = order;
            },
        });
    };

    return {
        init: me.init,
    };
}());
